(() => {
  const finder = document.getElementById('hs-board-finder');

  if (!finder || finder.dataset.v9Initialized === 'true') return;

  finder.dataset.v9Initialized = 'true';

  const steps = Array.from(
    finder.querySelectorAll('[data-step]')
  );

  const progressBar = finder.querySelector(
    '[data-progress-bar]'
  );

  const currentStepText = finder.querySelector(
    '[data-current-step]'
  );

  const previousButton = finder.querySelector(
    '[data-previous-step]'
  );

  const submitButton = finder.querySelector(
    '[data-find-board]'
  );

  const restartButton = finder.querySelector(
    '[data-restart-finder]'
  );

  const errorBox = finder.querySelector(
    '[data-finder-error]'
  );

  const loadingBox = finder.querySelector(
    '[data-finder-loading]'
  );

  const resultBox = finder.querySelector(
    '[data-finder-result]'
  );

  const scoreBox = finder.querySelector(
    '[data-result-score]'
  );

  const resultTitle = finder.querySelector(
    '[data-result-title]'
  );

  const resultDescription = finder.querySelector(
    '[data-result-description]'
  );

  const recommendedTypeBox = finder.querySelector(
    '[data-recommended-type]'
  );

  const recommendedVolumeBox = finder.querySelector(
    '[data-recommended-volume]'
  );

  const alternativeTypesBox = finder.querySelector(
    '[data-alternative-types]'
  );

  const recommendationNoteBox = finder.querySelector(
    '[data-recommendation-note]'
  );

  let productGrid = finder.querySelector(
    '[data-finder-products]'
  );

  if (!productGrid) {
    productGrid = document.createElement('div');

    productGrid.className =
      'hs-board-finder__products';

    productGrid.setAttribute(
      'data-finder-products',
      ''
    );

    resultBox.insertAdjacentElement(
      'afterend',
      productGrid
    );
  }

  let currentStep = 1;
  let cataloguePromise = null;

  const SCORE_LABELS = {
    top: 'Notre recommandation',
    excellent: 'Excellente alternative',
    veryGood: 'Très bon choix',
    good: 'Bon choix',
    consider: 'À considérer'
  };

  function clamp(value, min, max) {
    return Math.min(
      max,
      Math.max(min, value)
    );
  }

  function normalizeText(value) {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function parseList(value) {
    if (Array.isArray(value)) {
      return value
        .map(String)
        .filter(Boolean);
    }

    if (!value) {
      return [];
    }

    return String(value)
      .split(/[,;|]/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function hasAnyToken(values, tokens) {
    const haystack = parseList(values)
      .map(normalizeText)
      .join(' ');

    return tokens.some((token) =>
      haystack.includes(
        normalizeText(token)
      )
    );
  }

  function getSelectedValue(groupName) {
    return finder.querySelector(
      `input[name="${groupName}"]:checked`
    )?.value || '';
  }

  function getAnswers() {
    return {
      niveau: getSelectedValue(
        'hs-niveau'
      ),

      vagues: getSelectedValue(
        'hs-vagues'
      ),

      poids: getSelectedValue(
        'hs-poids'
      ),

      taille: getSelectedValue(
        'hs-taille'
      ),

      style: getSelectedValue(
        'hs-style'
      )
    };
  }

  function showStep(stepNumber) {
    currentStep = stepNumber;

    steps.forEach((step) => {
      const isCurrent =
        Number(step.dataset.step) ===
        currentStep;

      step.hidden = !isCurrent;

      step.classList.toggle(
        'is-active',
        isCurrent
      );
    });

    if (progressBar) {
      progressBar.style.width =
        `${currentStep * 20}%`;
    }

    if (currentStepText) {
      currentStepText.textContent =
        currentStep;
    }

    if (previousButton) {
      previousButton.hidden =
        currentStep === 1;
    }

    if (submitButton) {
      submitButton.hidden =
        currentStep !== 5;
    }

    if (errorBox) {
      errorBox.hidden = true;
    }
  }

  function getWeightEstimate(
    weightRange
  ) {
    return {
      'Moins de 75kg': 68,
      '75 à 90kg': 82,
      '90 à 105kg': 97,
      'Plus de 105kg': 112
    }[weightRange] || 82;
  }

  function calculateRecommendedVolume(
    answers
  ) {
    const levelMultipliers = {
      Débutant: 0.75,
      Intermédiaire: 0.52,
      Confirmé: 0.38
    };

    const heightAdjustments = {
      'Moins de 165cm': -2,
      '165 à 175cm': 0,
      '175 à 185cm': 2,
      'Plus de 185cm': 4
    };

    const styleAdjustments = {
      Balade: 4,
      Polyvalence: 1,
      Performance: -2
    };

    const waveAdjustments = {
      Petites: 2,
      Polyvalentes: 0,
      Puissantes: -1
    };

    const target =
      getWeightEstimate(
        answers.poids
      ) *
        (
          levelMultipliers[
            answers.niveau
          ] || 0.52
        ) +
      (
        heightAdjustments[
          answers.taille
        ] || 0
      ) +
      (
        styleAdjustments[
          answers.style
        ] || 0
      ) +
      (
        waveAdjustments[
          answers.vagues
        ] || 0
      );

    const roundedTarget = Math.max(
      20,
      Math.round(target * 10) / 10
    );

    const tolerance =
      answers.niveau === 'Débutant'
        ? 0.18
        : answers.niveau ===
            'Intermédiaire'
          ? 0.14
          : 0.11;

    return {
      target: roundedTarget,

      min:
        Math.round(
          roundedTarget *
            (1 - tolerance) *
            10
        ) / 10,

      max:
        Math.round(
          roundedTarget *
            (1 + tolerance) *
            10
        ) / 10
    };
  }

  async function loadCatalogue() {
    if (cataloguePromise) {
      return cataloguePromise;
    }

    cataloguePromise = (async () => {
      const products = [];

      let page = 1;
      let hasMore = true;

      while (
        hasMore &&
        page <= 20
      ) {
        const sectionUrl = new URL(
          finder.dataset
            .dataSectionUrl ||
            finder.dataset
              .collectionUrl,
          window.location.origin
        );

        sectionUrl.searchParams.set(
          'page',
          String(page)
        );

        sectionUrl.searchParams.set(
          'section_id',
          'hs-surfboard-finder-data'
        );

        const response = await fetch(
          sectionUrl.toString(),
          {
            credentials:
              'same-origin',

            headers: {
              'X-Requested-With':
                'XMLHttpRequest'
            }
          }
        );

        if (!response.ok) {
          throw new Error(
            'Impossible de charger les planches.'
          );
        }

        const html =
          await response.text();

        const documentObject =
          new DOMParser()
            .parseFromString(
              html,
              'text/html'
            );

        const dataNode =
          documentObject.querySelector(
            '[data-hs-surfboard-page]'
          );

        if (!dataNode) {
          throw new Error(
            'La section de données du configurateur est introuvable.'
          );
        }

        const payload = JSON.parse(
          dataNode.textContent
        );

        products.push(
          ...(payload.products || [])
        );

        hasMore = Boolean(
          payload.hasMore
        );

        page += 1;
      }

      return products
        .map((product) => ({
          ...product,

          practiceTypes: parseList(
            product.practiceTypes
          ),

          surferTypes: parseList(
            product.surferTypes
          ),

          constructionValues:
            parseList(
              product.construction
            ),

          orientationValues:
            parseList(
              product.orientation
            ),

          shapeValue:
            String(
              product.shape || ''
            ).trim(),

          finSetupValues:
            parseList(
              product.finSetup
            ),

          lengthInches:
            Number(
              product.lengthInches
            ) || 0,

          widthInches:
            Number(
              product.widthInches
            ) || 0,

          thicknessInches:
            Number(
              product.thicknessInches
            ) || 0
        }))
        .filter((product) => {
          return (
            product.available &&
            (
              product.variants ||
              []
            ).some(
              (variant) =>
                variant.available
            )
          );
        });
    })();

    return cataloguePromise;
  }

  function getLevelNumber(level) {
    return {
      Débutant: 1,
      Intermédiaire: 2,
      Confirmé: 3
    }[level] || 2;
  }

  function parseLevel(
    value,
    fallback
  ) {
    const numeric =
      Number(value);

    if (
      Number.isFinite(numeric) &&
      numeric >= 1 &&
      numeric <= 3
    ) {
      return numeric;
    }

    const normalized =
      normalizeText(value);

    if (
      normalized.includes('debut')
    ) {
      return 1;
    }

    if (
      normalized.includes('inter')
    ) {
      return 2;
    }

    if (
      normalized.includes('confirm') ||
      normalized.includes('avance') ||
      normalized.includes('expert')
    ) {
      return 3;
    }

    return fallback;
  }
    function calculateVolumeScore(
    variantVolume,
    targetVolume,
    level
  ) {
    const volume = Number(
      variantVolume
    );

    if (
      !Number.isFinite(volume) ||
      volume <= 0
    ) {
      return {
        score: 25,
        difference: null,
        relativeDifference: null
      };
    }

    const difference =
      Math.abs(
        volume -
        targetVolume
      );

    const relativeDifference =
      difference /
      targetVolume;

    const sigmaByLevel = {
      Débutant: 0.18,
      Intermédiaire: 0.14,
      Confirmé: 0.11
    };

    const sigma =
      sigmaByLevel[level] ||
      0.14;

    const gaussianScore =
      100 *
      Math.exp(
        -Math.pow(
          relativeDifference,
          2
        ) /
          (
            2 *
            Math.pow(
              sigma,
              2
            )
          )
      );

    return {
      score: clamp(
        gaussianScore,
        0,
        100
      ),

      difference,

      relativeDifference
    };
  }

  function getBestAvailableVariant(
    product,
    volumeRecommendation,
    answers
  ) {
    const variants =
      (
        product.variants ||
        []
      )
        .filter(
          (variant) =>
            variant.available
        )
        .map((variant) => {
          const volumeResult =
            calculateVolumeScore(
              variant.volume,
              volumeRecommendation.target,
              answers.niveau
            );

          return {
            ...variant,

            volumeScore:
              volumeResult.score,

            volumeDifference:
              volumeResult.difference,

            relativeVolumeDifference:
              volumeResult.relativeDifference
          };
        })
        .sort(
          (
            variantA,
            variantB
          ) => {
            if (
              variantB.volumeScore !==
              variantA.volumeScore
            ) {
              return (
                variantB.volumeScore -
                variantA.volumeScore
              );
            }

            return (
              Number(
                variantA.price
              ) || 0
            ) -
              (
                Number(
                  variantB.price
                ) || 0
              );
          }
        );

    return variants[0] || null;
  }

  function getScoreValue(
    scores,
    key
  ) {
    return clamp(
      Number(
        scores?.[key]
      ) || 0,
      0,
      10
    );
  }

  function getLevelWeights(
    answers
  ) {
    const weights = {
      Débutant: {
        volume: 2.8,
        paddle: 2.2,
        stability: 3.6,
        forgiveness: 3.2,
        maneuverability: 0.7,
        performance: 0.3
      },

      Intermédiaire: {
        volume: 3,
        paddle: 1.5,
        stability: 1.8,
        forgiveness: 1.5,
        maneuverability: 2,
        performance: 2
      },

      Confirmé: {
        volume: 2.4,
        paddle: 1,
        stability: 0.5,
        forgiveness: 0.5,
        maneuverability: 3,
        performance: 3.4
      }
    };

    return (
      weights[
        answers.niveau
      ] ||
      weights.Intermédiaire
    );
  }

  function getStyleWeights(
    answers
  ) {
    const weights = {
      Balade: {
        paddle: 2.8,
        stability: 3,
        forgiveness: 3,
        maneuverability: 0.5,
        performance: 0.2
      },

      Polyvalence: {
        paddle: 1.6,
        stability: 1.5,
        forgiveness: 1.4,
        maneuverability: 1.8,
        performance: 1.8
      },

      Performance: {
        paddle: 0.7,
        stability: 0.3,
        forgiveness: 0.3,
        maneuverability: 3,
        performance: 3.4
      }
    };

    return (
      weights[
        answers.style
      ] ||
      weights.Polyvalence
    );
  }

  function getWaveWeights(
    answers
  ) {
    const weights = {
      Petites: {
        waveSmall: 3.2,
        waveWeak: 3,
        waveVersatile: 1,
        waveFast: 0.3,
        waveHollow: 0.1,
        wavePowerful: 0.1,
        waveBig: 0
      },

      Polyvalentes: {
        waveSmall: 0.8,
        waveWeak: 0.7,
        waveVersatile: 3.2,
        waveFast: 1.2,
        waveHollow: 0.6,
        wavePowerful: 0.8,
        waveBig: 0.3
      },

      Puissantes: {
        waveSmall: 0.1,
        waveWeak: 0.1,
        waveVersatile: 0.8,
        waveFast: 2.5,
        waveHollow: 2.7,
        wavePowerful: 3,
        waveBig: 1.8
      }
    };

    return (
      weights[
        answers.vagues
      ] ||
      weights.Polyvalentes
    );
  }

  function getPracticeTypeBonus(
    product,
    answers
  ) {
    let bonus = 0;

    const values =
      product.practiceTypes;

    if (
      answers.niveau ===
        'Débutant' &&
      hasAnyToken(
        values,
        [
          'débutant',
          'debutant',
          'apprentissage',
          'learning',
          'école',
          'ecole',
          'initiation',
          'softboard',
          'mini malibu'
        ]
      )
    ) {
      bonus += 8;
    }

    if (
      answers.style ===
        'Balade' &&
      hasAnyToken(
        values,
        [
          'loisir',
          'cruising',
          'glisse',
          'longboard',
          'mini malibu',
          'mid length',
          'midlength',
          'easy',
          'facile'
        ]
      )
    ) {
      bonus += 6;
    }

    if (
      answers.style ===
        'Polyvalence' &&
      hasAnyToken(
        values,
        [
          'polyvalent',
          'polyvalence',
          'all round',
          'all-round',
          'hybrid',
          'hybride',
          'funboard',
          'mid length',
          'midlength'
        ]
      )
    ) {
      bonus += 6;
    }

    if (
      answers.style ===
        'Performance' &&
      hasAnyToken(
        values,
        [
          'performance',
          'shortboard',
          'high performance',
          'hpsb',
          'competition',
          'compétition',
          'contest'
        ]
      )
    ) {
      bonus += 7;
    }

    if (
      answers.vagues ===
        'Petites' &&
      hasAnyToken(
        values,
        [
          'small wave',
          'petites vagues',
          'groveler',
          'fish',
          'mini simmons',
          'summer',
          'faible puissance'
        ]
      )
    ) {
      bonus += 7;
    }

    if (
      answers.vagues ===
        'Polyvalentes' &&
      hasAnyToken(
        values,
        [
          'all round',
          'all-round',
          'polyvalent',
          'hybrid',
          'hybride',
          'daily driver',
          'everyday'
        ]
      )
    ) {
      bonus += 5;
    }

    if (
      answers.vagues ===
        'Puissantes' &&
      hasAnyToken(
        values,
        [
          'powerful',
          'puissant',
          'hollow',
          'creux',
          'step up',
          'step-up',
          'gun',
          'big wave',
          'grosses vagues'
        ]
      )
    ) {
      bonus += 7;
    }

    return bonus;
  }

  function getSurferTypeBonus(
    product,
    answers
  ) {
    let bonus = 0;

    const values =
      product.surferTypes;

    if (
      answers.niveau ===
        'Débutant' &&
      hasAnyToken(
        values,
        [
          'débutant',
          'debutant',
          'beginner',
          'novice',
          'occasionnel',
          'loisir'
        ]
      )
    ) {
      bonus += 8;
    }

    if (
      answers.niveau ===
        'Intermédiaire' &&
      hasAnyToken(
        values,
        [
          'intermédiaire',
          'intermediaire',
          'intermediate',
          'progression',
          'évolutif',
          'evolutif'
        ]
      )
    ) {
      bonus += 6;
    }

    if (
      answers.niveau ===
        'Confirmé' &&
      hasAnyToken(
        values,
        [
          'confirmé',
          'confirme',
          'advanced',
          'expert',
          'compétiteur',
          'competiteur',
          'performance'
        ]
      )
    ) {
      bonus += 7;
    }

    if (
      answers.style ===
        'Balade' &&
      hasAnyToken(
        values,
        [
          'loisir',
          'occasionnel',
          'longboarder',
          'cruiser',
          'glisse'
        ]
      )
    ) {
      bonus += 4;
    }

    if (
      answers.style ===
        'Performance' &&
      hasAnyToken(
        values,
        [
          'shortboarder',
          'compétiteur',
          'competiteur',
          'performance',
          'expert'
        ]
      )
    ) {
      bonus += 5;
    }

    return bonus;
  }

  function getConstructionBonus(
    product,
    answers
  ) {
    let bonus = 0;

    const values =
      product.constructionValues;

    if (
      answers.niveau ===
        'Débutant' &&
      hasAnyToken(
        values,
        [
          'soft',
          'mousse',
          'softop',
          'soft top',
          'eps',
          'tuflite'
        ]
      )
    ) {
      bonus += 4;
    }

    if (
      answers.style ===
        'Performance' &&
      hasAnyToken(
        values,
        [
          'pu',
          'polyurethane',
          'carbon',
          'carbone',
          'pro',
          'fusion',
          'hd',
          'epoxy'
        ]
      )
    ) {
      bonus += 3;
    }

    if (
      answers.style ===
        'Balade' &&
      hasAnyToken(
        values,
        [
          'durable',
          'tuflite',
          'soft',
          'mousse',
          'epoxy'
        ]
      )
    ) {
      bonus += 2;
    }

    return bonus;
  }

  function getOrientationBonus(
    product,
    answers
  ) {
    let bonus = 0;

    const values =
      product.orientationValues;

    if (
      answers.style ===
        'Balade' &&
      hasAnyToken(
        values,
        [
          'loisir',
          'glisse',
          'cruising',
          'easy',
          'facile',
          'stabilité',
          'stabilite',
          'noseriding'
        ]
      )
    ) {
      bonus += 5;
    }

    if (
      answers.style ===
        'Polyvalence' &&
      hasAnyToken(
        values,
        [
          'polyvalent',
          'all round',
          'all-round',
          'everyday',
          'daily'
        ]
      )
    ) {
      bonus += 5;
    }

    if (
      answers.style ===
        'Performance' &&
      hasAnyToken(
        values,
        [
          'performance',
          'radical',
          'competition',
          'compétition',
          'vertical',
          'speed'
        ]
      )
    ) {
      bonus += 6;
    }

    if (
      answers.vagues ===
        'Petites' &&
      hasAnyToken(
        values,
        [
          'small wave',
          'petites vagues',
          'summer',
          'faible puissance'
        ]
      )
    ) {
      bonus += 5;
    }

    if (
      answers.vagues ===
        'Puissantes' &&
      hasAnyToken(
        values,
        [
          'powerful',
          'puissant',
          'creux',
          'hollow',
          'big wave',
          'grosses vagues'
        ]
      )
    ) {
      bonus += 5;
    }

    return bonus;
  }

  function getShapeCompatibility(
    product,
    answers
  ) {
    const shape =
      normalizeText(
        product.shapeValue ||
        product.shape ||
        ''
      );

    if (!shape) {
      return {
        bonus: 0,
        excluded: false
      };
    }

    const isAny = (...tokens) =>
      tokens.some((token) =>
        shape.includes(
          normalizeText(token)
        )
      );

    let bonus = 0;
    let excluded = false;

    if (
      answers.niveau ===
      'Débutant'
    ) {
      if (
        isAny(
          'softboard',
          'mini malibu',
          'funboard',
          'longboard',
          'egg',
          'sup surf'
        )
      ) {
        bonus += 14;
      }

      if (
        isAny(
          'shortboard',
          'performance shortboard',
          'step up',
          'gun',
          'performance longboard'
        )
      ) {
        excluded = true;
      }

      if (
        isAny(
          'fish',
          'groveler',
          'hybrid',
          'mid length'
        )
      ) {
        bonus -= 5;
      }
    }

    if (
      answers.niveau ===
      'Intermédiaire'
    ) {
      if (
        isAny(
          'hybrid',
          'egg',
          'funboard',
          'mid length',
          'fish',
          'groveler',
          'mini malibu'
        )
      ) {
        bonus += 9;
      }

      if (
        isAny(
          'gun',
          'step up'
        ) &&
        answers.vagues !==
          'Puissantes'
      ) {
        bonus -= 10;
      }
    }

    if (
      answers.niveau ===
      'Confirmé'
    ) {
      if (
        answers.style ===
          'Performance' &&
        isAny(
          'shortboard',
          'performance shortboard',
          'step up',
          'gun',
          'performance longboard'
        )
      ) {
        bonus += 12;
      }

      if (
        answers.style ===
          'Performance' &&
        isAny(
          'softboard',
          'mini malibu',
          'sup surf'
        )
      ) {
        bonus -= 12;
      }
    }

    if (
      answers.style ===
        'Balade'
    ) {
      if (
        isAny(
          'longboard',
          'mini malibu',
          'mid length',
          'egg',
          'funboard',
          'softboard',
          'sup surf'
        )
      ) {
        bonus += 10;
      }

      if (
        isAny(
          'shortboard',
          'step up',
          'gun'
        )
      ) {
        bonus -= 12;
      }
    }

    if (
      answers.style ===
        'Polyvalence'
    ) {
      if (
        isAny(
          'hybrid',
          'egg',
          'funboard',
          'mid length',
          'fish',
          'groveler'
        )
      ) {
        bonus += 9;
      }
    }

    if (
      answers.style ===
        'Performance'
    ) {
      if (
        isAny(
          'shortboard',
          'performance shortboard',
          'step up',
          'performance longboard'
        )
      ) {
        bonus += 11;
      }

      if (
        isAny(
          'softboard',
          'mini malibu',
          'sup surf'
        )
      ) {
        bonus -= 10;
      }
    }

    if (
      answers.vagues ===
        'Petites'
    ) {
      if (
        isAny(
          'fish',
          'groveler',
          'mini simmons',
          'longboard',
          'mini malibu',
          'softboard'
        )
      ) {
        bonus += 11;
      }

      if (
        isAny(
          'gun',
          'step up'
        )
      ) {
        bonus -= 14;
      }
    }

    if (
      answers.vagues ===
        'Polyvalentes' &&
      isAny(
        'hybrid',
        'egg',
        'funboard',
        'mid length'
      )
    ) {
      bonus += 8;
    }

    if (
      answers.vagues ===
        'Puissantes'
    ) {
      if (
        isAny(
          'shortboard',
          'step up',
          'gun'
        )
      ) {
        bonus += 12;
      }

      if (
        isAny(
          'softboard',
          'mini malibu',
          'groveler',
          'sup surf'
        )
      ) {
        bonus -= 12;
      }
    }

    return {
      bonus,
      excluded
    };
  }

  function getDimensionCompatibility(
    product,
    answers
  ) {
    const length =
      Number(
        product.lengthInches
      ) || 0;

    const width =
      Number(
        product.widthInches
      ) || 0;

    const thickness =
      Number(
        product.thicknessInches
      ) || 0;

    let bonus = 0;

    if (length > 0) {
      if (
        answers.niveau ===
          'Débutant'
      ) {
        if (length >= 84) {
          bonus += 8;
        } else if (length < 76) {
          bonus -= 14;
        }
      }

      if (
        answers.niveau ===
          'Intermédiaire'
      ) {
        if (
          length >= 72 &&
          length <= 96
        ) {
          bonus += 4;
        }
      }

      if (
        answers.niveau ===
          'Confirmé' &&
        answers.style ===
          'Performance' &&
        length >= 66 &&
        length <= 84
      ) {
        bonus += 4;
      }

      if (
        answers.style ===
          'Balade' &&
        length >= 84
      ) {
        bonus += 6;
      }

      if (
        answers.vagues ===
          'Petites' &&
        length >= 78
      ) {
        bonus += 3;
      }
    }

    if (width > 0) {
      if (
        answers.niveau ===
          'Débutant'
      ) {
        if (width >= 21) {
          bonus += 5;
        } else if (width < 19.5) {
          bonus -= 8;
        }
      }

      if (
        answers.style ===
          'Performance' &&
        width <= 20.5
      ) {
        bonus += 3;
      }

      if (
        answers.vagues ===
          'Petites' &&
        width >= 20.5
      ) {
        bonus += 3;
      }
    }

    if (
      thickness > 0 &&
      answers.niveau ===
        'Débutant' &&
      thickness >= 2.6
    ) {
      bonus += 2;
    }

    return bonus;
  }

  function getFinSetupBonus(
    product,
    answers
  ) {
    const values =
      product.finSetupValues ||
      parseList(
        product.finSetup
      );

    let bonus = 0;

    if (
      answers.vagues ===
        'Petites' &&
      hasAnyToken(
        values,
        [
          'twin',
          'twin fin',
          'quad'
        ]
      )
    ) {
      bonus += 3;
    }

    if (
      answers.style ===
        'Performance' &&
      hasAnyToken(
        values,
        [
          'thruster',
          'five fin',
          'quad'
        ]
      )
    ) {
      bonus += 3;
    }

    if (
      answers.style ===
        'Balade' &&
      hasAnyToken(
        values,
        [
          'single fin',
          '2+1'
        ]
      )
    ) {
      bonus += 3;
    }

    return bonus;
  }

  function getLevelCompatibility(
    product,
    answers
  ) {
    const scores =
      product.scores || {};

    const userLevel =
      getLevelNumber(
        answers.niveau
      );

    const minimumLevel =
      parseLevel(
        scores.levelMin,
        1
      );

    const maximumLevel =
      parseLevel(
        scores.levelMax,
        3
      );

    if (
      userLevel <
      minimumLevel
    ) {
      return {
        compatible: false,
        penalty: 0,
        minimumLevel,
        maximumLevel
      };
    }

    let penalty = 0;

    if (
      userLevel >
      maximumLevel
    ) {
      penalty =
        (
          userLevel -
          maximumLevel
        ) * 8;
    }

    return {
      compatible: true,
      penalty,
      minimumLevel,
      maximumLevel
    };
  }

  function scoreProduct(
    product,
    answers,
    volumeRecommendation
  ) {
    const scores =
      product.scores || {};

    const levelCompatibility =
      getLevelCompatibility(
        product,
        answers
      );

    if (
      !levelCompatibility.compatible
    ) {
      return null;
    }

    const bestVariant =
      getBestAvailableVariant(
        product,
        volumeRecommendation,
        answers
      );

    if (!bestVariant) {
      return null;
    }

    const shapeCompatibility =
      getShapeCompatibility(
        product,
        answers
      );

    if (
      shapeCompatibility.excluded
    ) {
      return null;
    }

    let weightedScore = 0;
    let totalWeight = 0;

    function addScore(
      value,
      weight,
      scale = 10
    ) {
      const numericValue =
        Number(value) || 0;

      const normalizedValue =
        scale === 100
          ? clamp(
              numericValue,
              0,
              100
            )
          : clamp(
              numericValue,
              0,
              10
            ) * 10;

      weightedScore +=
        normalizedValue *
        weight;

      totalWeight += weight;
    }

    const levelWeights =
      getLevelWeights(
        answers
      );

    const styleWeights =
      getStyleWeights(
        answers
      );

    const waveWeights =
      getWaveWeights(
        answers
      );

    addScore(
      bestVariant.volumeScore,
      levelWeights.volume,
      100
    );

    [
      'paddle',
      'stability',
      'forgiveness',
      'maneuverability',
      'performance'
    ].forEach((key) => {
      const combinedWeight =
        (
          levelWeights[key] ||
          0
        ) +
        (
          styleWeights[key] ||
          0
        );

      if (
        combinedWeight >
        0
      ) {
        addScore(
          getScoreValue(
            scores,
            key
          ),
          combinedWeight
        );
      }
    });

    Object.entries(
      waveWeights
    ).forEach(
      ([key, weight]) => {
        if (
          weight <= 0
        ) {
          return;
        }

        addScore(
          getScoreValue(
            scores,
            key
          ),
          weight
        );
      }
    );

    let compatibility =
      totalWeight > 0
        ? weightedScore /
          totalWeight
        : 0;

    compatibility -=
      levelCompatibility.penalty;

    compatibility +=
      getPracticeTypeBonus(
        product,
        answers
      );

    compatibility +=
      getSurferTypeBonus(
        product,
        answers
      );

    compatibility +=
      getConstructionBonus(
        product,
        answers
      );

    compatibility +=
      getOrientationBonus(
        product,
        answers
      );

    compatibility +=
      shapeCompatibility.bonus;

    compatibility +=
      getDimensionCompatibility(
        product,
        answers
      );

    compatibility +=
      getFinSetupBonus(
        product,
        answers
      );

    if (
      answers.niveau ===
        'Débutant' &&
      getScoreValue(
        scores,
        'stability'
      ) < 5
    ) {
      compatibility -= 12;
    }

    if (
      answers.niveau ===
        'Débutant' &&
      getScoreValue(
        scores,
        'forgiveness'
      ) < 5
    ) {
      compatibility -= 10;
    }

    if (
      answers.style ===
        'Performance' &&
      getScoreValue(
        scores,
        'performance'
      ) < 5
    ) {
      compatibility -= 8;
    }

    if (
      answers.vagues ===
        'Puissantes' &&
      Math.max(
        getScoreValue(
          scores,
          'wavePowerful'
        ),
        getScoreValue(
          scores,
          'waveHollow'
        ),
        getScoreValue(
          scores,
          'waveFast'
        )
      ) < 5
    ) {
      compatibility -= 10;
    }

    if (
      bestVariant
        .relativeVolumeDifference !==
        null &&
      bestVariant
        .relativeVolumeDifference >
        0.35
    ) {
      compatibility -= 14;
    }

    return {
      ...product,

      bestVariant,

      minimumLevel:
        levelCompatibility
          .minimumLevel,

      maximumLevel:
        levelCompatibility
          .maximumLevel,

      rawCompatibility:
        compatibility,

      compatibility:
        Math.round(
          clamp(
            compatibility,
            1,
            99
          )
        )
    };
  }
    function escapeHtml(value) {
    return String(
      value ?? ''
    ).replace(
      /[&<>"']/g,
      (character) => {
        const characters = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        };

        return characters[
          character
        ];
      }
    );
  }

  function formatMoney(cents) {
    const activeCurrency =
      window.Shopify
        ?.currency
        ?.active ||
      'EUR';

    return new Intl.NumberFormat(
      document.documentElement.lang ||
        'fr-FR',
      {
        style: 'currency',
        currency: activeCurrency
      }
    ).format(
      (
        Number(cents) ||
        0
      ) / 100
    );
  }

  function getProductTypeLabel(
    product
  ) {
    const shape =
      String(
        product.shapeValue ||
        product.shape ||
        ''
      ).trim();

    if (shape) {
      return shape;
    }

    const type =
      String(
        product.productType ||
        ''
      ).trim();

    if (type) {
      return type;
    }

    const practiceTypes =
      parseList(
        product.practiceTypes
      );

    if (practiceTypes.length) {
      return practiceTypes[0];
    }

    return 'Planche de surf';
  }

  function getResultLabel(
    score,
    index
  ) {
    if (index === 0) {
      return SCORE_LABELS.top;
    }

    if (score >= 88) {
      return SCORE_LABELS.excellent;
    }

    if (score >= 78) {
      return SCORE_LABELS.veryGood;
    }

    if (score >= 67) {
      return SCORE_LABELS.good;
    }

    return SCORE_LABELS.consider;
  }

  function getMatchTitle(score) {
    if (score >= 90) {
      return 'Excellente compatibilité';
    }

    if (score >= 80) {
      return 'Très bonne compatibilité';
    }

    if (score >= 68) {
      return 'Bonne compatibilité';
    }

    return 'Sélection compatible';
  }

  function getRecommendationText(
    answers
  ) {
    const parts = [];

    if (
      answers.niveau ===
      'Débutant'
    ) {
      parts.push(
        'Nous avons écarté les planches trop techniques et privilégié la stabilité, la tolérance et la facilité de rame'
      );
    }

    if (
      answers.niveau ===
      'Intermédiaire'
    ) {
      parts.push(
        'Nous avons recherché un équilibre entre progression, maniabilité, stabilité et performance'
      );
    }

    if (
      answers.niveau ===
      'Confirmé'
    ) {
      parts.push(
        'Nous avons privilégié la précision, la maniabilité et le potentiel de performance'
      );
    }

    if (
      answers.vagues ===
      'Petites'
    ) {
      parts.push(
        'avec une attention particulière portée au départ rapide et à l’efficacité dans les vagues peu puissantes'
      );
    }

    if (
      answers.vagues ===
      'Polyvalentes'
    ) {
      parts.push(
        'avec une préférence pour les modèles capables de fonctionner dans un large éventail de conditions'
      );
    }

    if (
      answers.vagues ===
      'Puissantes'
    ) {
      parts.push(
        'avec une priorité donnée au contrôle, à la vitesse et à la tenue dans les vagues rapides ou creuses'
      );
    }

    if (!parts.length) {
      return 'Les planches ont été classées selon votre niveau, votre gabarit, votre style et les conditions recherchées.';
    }

    return `${parts.join(' ') }.`;
  }

  function getProductReasons(
    item,
    answers
  ) {
    const scores =
      item.scores || {};

    const reasons = [];

    function addReason(
      value,
      label
    ) {
      const numericValue =
        Number(value) || 0;

      if (
        numericValue > 0
      ) {
        reasons.push({
          value: numericValue,
          label
        });
      }
    }

    if (
      item.bestVariant &&
      Number(
        item.bestVariant.volumeScore
      ) >= 85
    ) {
      reasons.push({
        value: 10,
        label:
          'Volume très proche de votre besoin'
      });
    }

    if (
      answers.style ===
      'Balade'
    ) {
      addReason(
        scores.stability,
        'Très stable'
      );

      addReason(
        scores.forgiveness,
        'Tolérante'
      );

      addReason(
        scores.paddle,
        'Facile à la rame'
      );
    }

    if (
      answers.style ===
      'Polyvalence'
    ) {
      addReason(
        scores.waveVersatile,
        'Polyvalente'
      );

      addReason(
        scores.maneuverability,
        'Maniable'
      );

      addReason(
        scores.paddle,
        'Bonne rame'
      );

      addReason(
        scores.performance,
        'Bon potentiel de progression'
      );
    }

    if (
      answers.style ===
      'Performance'
    ) {
      addReason(
        scores.performance,
        'Performante'
      );

      addReason(
        scores.maneuverability,
        'Très maniable'
      );

      addReason(
        scores.waveFast,
        'À l’aise dans les vagues rapides'
      );
    }

    if (
      answers.vagues ===
      'Petites'
    ) {
      addReason(
        Math.max(
          Number(
            scores.waveSmall
          ) || 0,
          Number(
            scores.waveWeak
          ) || 0
        ),
        'Efficace dans les petites vagues'
      );
    }

    if (
      answers.vagues ===
      'Polyvalentes'
    ) {
      addReason(
        scores.waveVersatile,
        'Adaptée à de nombreuses conditions'
      );
    }

    if (
      answers.vagues ===
      'Puissantes'
    ) {
      addReason(
        Math.max(
          Number(
            scores.wavePowerful
          ) || 0,
          Number(
            scores.waveHollow
          ) || 0,
          Number(
            scores.waveFast
          ) || 0
        ),
        'Adaptée aux vagues puissantes'
      );
    }

    if (
      answers.niveau ===
        'Débutant' &&
      hasAnyToken(
        item.constructionValues,
        [
          'soft',
          'mousse',
          'soft top',
          'softop'
        ]
      )
    ) {
      reasons.push({
        value: 9,
        label:
          'Construction rassurante pour progresser'
      });
    }

    const shapeLabel =
      String(
        item.shapeValue ||
        item.shape ||
        ''
      ).trim();

    if (shapeLabel) {
      reasons.push({
        value: 8.5,
        label:
          `Shape ${shapeLabel} adapté à votre profil`
      });
    }

    if (
      Number(
        item.lengthInches
      ) > 0 &&
      answers.niveau ===
        'Débutant' &&
      Number(
        item.lengthInches
      ) >= 84
    ) {
      reasons.push({
        value: 8,
        label:
          'Longueur rassurante pour faciliter la progression'
      });
    }

    return reasons
      .sort(
        (
          reasonA,
          reasonB
        ) =>
          reasonB.value -
          reasonA.value
      )
      .filter(
        (
          reason,
          index,
          array
        ) =>
          array.findIndex(
            (item) =>
              item.label ===
              reason.label
          ) === index
      )
      .slice(0, 3)
      .map(
        (reason) =>
          reason.label
      );
  }

  function getMainRecommendation(
    products
  ) {
    const firstProduct =
      products[0];

    if (!firstProduct) {
      return '';
    }

    return getProductTypeLabel(
      firstProduct
    );
  }

  function getAlternativeRecommendations(
    products
  ) {
    const types = products
      .slice(1)
      .map(
        getProductTypeLabel
      )
      .filter(Boolean)
      .filter(
        (
          type,
          index,
          array
        ) =>
          array.indexOf(
            type
          ) === index
      )
      .slice(0, 2);

    return types.join(' · ');
  }

  function renderProductCards(
    products,
    answers
  ) {
    if (!productGrid) {
      throw new Error(
        'La zone de résultats du configurateur est introuvable.'
      );
    }

    productGrid.innerHTML =
      products
        .map(
          (
            product,
            index
          ) => {
            const variant =
              product.bestVariant;

            const image =
              variant.image ||
              product.image ||
              '';

            const productUrl =
              `${product.url}?variant=${variant.id}`;

            const volume =
              Number(
                variant.volume
              ) > 0
                ? `${variant.volume} L`
                : 'Volume non renseigné';

            const reasons =
              getProductReasons(
                product,
                answers
              );

            const reasonsHtml =
              reasons
                .map(
                  (reason) =>
                    `<li>${escapeHtml(reason)}</li>`
                )
                .join('');

            const resultLabel =
              getResultLabel(
                product.compatibility,
                index
              );

            const productType =
              getProductTypeLabel(
                product
              );

            const compareAtPrice =
              Number(
                variant.compareAtPrice
              ) || 0;

            const price =
              Number(
                variant.price
              ) || 0;

            const compareAtHtml =
              compareAtPrice >
              price
                ? `
                  <del class="hs-finder-product__compare-price">
                    ${formatMoney(compareAtPrice)}
                  </del>
                `
                : '';

            return `
              <article class="hs-finder-product">

                <a
                  class="hs-finder-product__image"
                  href="${escapeHtml(productUrl)}"
                >
                  ${
                    image
                      ? `
                        <img
                          src="${escapeHtml(image)}"
                          alt="${escapeHtml(product.title)}"
                          loading="${index < 3 ? 'eager' : 'lazy'}"
                          width="800"
                          height="800"
                        >
                      `
                      : ''
                  }

                  <span class="hs-finder-product__rank">
                    ${
                      index === 0
                        ? '🥇'
                        : `#${index + 1}`
                    }
                  </span>

                  <span class="hs-finder-product__match">
                    ${escapeHtml(resultLabel)}
                  </span>
                </a>

                <div class="hs-finder-product__body">

                  <p class="hs-finder-product__vendor">
                    ${escapeHtml(product.vendor)}
                  </p>

                  <p class="hs-finder-product__type">
                    ${escapeHtml(productType)}
                  </p>

                  <h4>
                    <a href="${escapeHtml(productUrl)}">
                      ${escapeHtml(product.title)}
                    </a>
                  </h4>

                  <div class="hs-finder-product__meta">

                    <strong>
                      ${escapeHtml(volume)}
                    </strong>

                    <span class="hs-finder-product__prices">
                      ${compareAtHtml}

                      <span>
                        ${formatMoney(price)}
                      </span>
                    </span>

                  </div>

                  <ul>
                    ${reasonsHtml}
                  </ul>

                  <a
                    class="hs-finder-product__cta"
                    href="${escapeHtml(productUrl)}"
                  >
                    Voir la planche
                  </a>

                </div>

              </article>
            `;
          }
        )
        .join('');
  }

  function saveProfile(
    answers,
    volumeRecommendation
  ) {
    try {
      localStorage.setItem(
        'hsSurfFinderProfile',
        JSON.stringify({
          ...answers,
          volumeRecommendation,
          savedAt:
            new Date()
              .toISOString()
        })
      );
    } catch (error) {
      console.warn(
        'Le profil du configurateur ne peut pas être enregistré.',
        error
      );
    }
  }

  function sendAnalytics(
    answers,
    volumeRecommendation,
    recommendations
  ) {
    const analyticsData = {
      event:
        'surfboard_finder_completed',

      surf_level:
        answers.niveau,

      wave_type:
        answers.vagues,

      weight_range:
        answers.poids,

      height_range:
        answers.taille,

      surf_style:
        answers.style,

      recommended_volume_target:
        volumeRecommendation.target,

      recommended_volume_min:
        volumeRecommendation.min,

      recommended_volume_max:
        volumeRecommendation.max,

      result_count:
        recommendations.length,

      top_product:
        recommendations[0]
          ?.title || '',

      top_product_type:
        recommendations[0]
          ? getProductTypeLabel(
              recommendations[0]
            )
          : '',

      top_product_shape:
        recommendations[0]
          ?.shapeValue ||
        recommendations[0]
          ?.shape ||
        '',

      top_compatibility:
        recommendations[0]
          ?.compatibility || 0
    };

    window.dataLayer =
      window.dataLayer || [];

    window.dataLayer.push(
      analyticsData
    );

    if (
      typeof window.gtag ===
      'function'
    ) {
      window.gtag(
        'event',
        'surfboard_finder_completed',
        analyticsData
      );
    }
  }

  function sortRecommendations(
    productA,
    productB
  ) {
    if (
      productB.rawCompatibility !==
      productA.rawCompatibility
    ) {
      return (
        productB.rawCompatibility -
        productA.rawCompatibility
      );
    }

    const volumeScoreA =
      Number(
        productA.bestVariant
          ?.volumeScore
      ) || 0;

    const volumeScoreB =
      Number(
        productB.bestVariant
          ?.volumeScore
      ) || 0;

    if (
      volumeScoreB !==
      volumeScoreA
    ) {
      return (
        volumeScoreB -
        volumeScoreA
      );
    }

    const performanceA =
      getScoreValue(
        productA.scores,
        'performance'
      );

    const performanceB =
      getScoreValue(
        productB.scores,
        'performance'
      );

    return (
      performanceB -
      performanceA
    );
  }
    function validateAnswers(
    answers
  ) {
    return Object.values(
      answers
    ).every(Boolean);
  }

  function setLoadingState(
    isLoading
  ) {
    if (loadingBox) {
      loadingBox.hidden =
        !isLoading;
    }

    if (submitButton) {
      submitButton.disabled =
        isLoading;

      submitButton.setAttribute(
        'aria-busy',
        String(isLoading)
      );
    }
  }

  function showError(
    message
  ) {
    if (!errorBox) {
      console.error(message);
      return;
    }

    errorBox.textContent =
      message;

    errorBox.hidden = false;

    errorBox.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  function hideError() {
    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }
  }

  function updateResultSummary(
    recommendations,
    answers,
    volumeRecommendation
  ) {
    const mainRecommendation =
      recommendations[0];

    if (!mainRecommendation) {
      return;
    }

    if (scoreBox) {
      scoreBox.textContent =
        `${mainRecommendation.compatibility}%`;
    }

    if (resultTitle) {
      resultTitle.textContent =
        getMatchTitle(
          mainRecommendation.compatibility
        );
    }

    if (resultDescription) {
      resultDescription.textContent =
        getRecommendationText(
          answers
        );
    }

    if (recommendedTypeBox) {
      recommendedTypeBox.textContent =
        getMainRecommendation(
          recommendations
        );
    }

    if (recommendedVolumeBox) {
      recommendedVolumeBox.textContent =
        `${volumeRecommendation.target} L`;

      recommendedVolumeBox.setAttribute(
        'title',
        `Plage conseillée : ${volumeRecommendation.min} à ${volumeRecommendation.max} litres`
      );
    }

    if (alternativeTypesBox) {
      const alternatives =
        getAlternativeRecommendations(
          recommendations
        );

      alternativeTypesBox.textContent =
        alternatives ||
        'Aucune alternative distincte';
    }

    if (recommendationNoteBox) {
      recommendationNoteBox.textContent =
        `Volume conseillé : environ ${volumeRecommendation.target} L, avec une plage pertinente comprise entre ${volumeRecommendation.min} L et ${volumeRecommendation.max} L.`;
    }
  }

  async function runSearch() {
    hideError();

    const answers =
      getAnswers();

    if (
      !validateAnswers(
        answers
      )
    ) {
      showError(
        'Veuillez sélectionner une réponse pour chaque question.'
      );

      return;
    }

    setLoadingState(true);

    if (resultBox) {
      resultBox.hidden = true;
    }

    if (productGrid) {
      productGrid.innerHTML = '';
      productGrid.hidden = true;
    }

    try {
      const volumeRecommendation =
        calculateRecommendedVolume(
          answers
        );

      const catalogue =
        await loadCatalogue();

      if (
        !Array.isArray(
          catalogue
        ) ||
        catalogue.length === 0
      ) {
        throw new Error(
          'Aucune planche disponible n’a été trouvée dans le catalogue.'
        );
      }

      const scoredProducts =
        catalogue
          .map((product) =>
            scoreProduct(
              product,
              answers,
              volumeRecommendation
            )
          )
          .filter(Boolean)
          .sort(
            sortRecommendations
          );

      let recommendations =
        scoredProducts.filter(
          (product) =>
            product.compatibility >=
            45
        );

      if (
        recommendations.length <
        4
      ) {
        recommendations =
          scoredProducts;
      }

      recommendations =
        recommendations.slice(
          0,
          8
        );

      if (
        recommendations.length ===
        0
      ) {
        throw new Error(
          'Aucune planche suffisamment compatible n’a été trouvée avec vos réponses.'
        );
      }

      updateResultSummary(
        recommendations,
        answers,
        volumeRecommendation
      );

      renderProductCards(
        recommendations,
        answers
      );

      saveProfile(
        answers,
        volumeRecommendation
      );

      sendAnalytics(
        answers,
        volumeRecommendation,
        recommendations
      );

      steps.forEach((step) => {
        step.hidden = true;
        step.classList.remove(
          'is-active'
        );
      });

      if (previousButton) {
        previousButton.hidden = true;
      }

      if (submitButton) {
        submitButton.hidden = true;
      }

      if (resultBox) {
        resultBox.hidden = false;
      }

      if (productGrid) {
        productGrid.hidden = false;
      }

      resultBox
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
    } catch (error) {
      console.error(
        'Erreur du configurateur de planches :',
        error
      );

      showError(
        error instanceof Error
          ? error.message
          : 'Une erreur est survenue pendant la recherche.'
      );

      showStep(
        currentStep
      );
    } finally {
      setLoadingState(false);
    }
  }

  function resetFinder() {
    finder
      .querySelectorAll(
        'input[type="radio"]'
      )
      .forEach((input) => {
        input.checked = false;
      });

    hideError();

    if (resultBox) {
      resultBox.hidden = true;
    }

    if (productGrid) {
      productGrid.hidden = true;
      productGrid.innerHTML = '';
    }

    if (scoreBox) {
      scoreBox.textContent = '';
    }

    if (resultTitle) {
      resultTitle.textContent = '';
    }

    if (resultDescription) {
      resultDescription.textContent = '';
    }

    if (recommendedTypeBox) {
      recommendedTypeBox.textContent = '';
    }

    if (recommendedVolumeBox) {
      recommendedVolumeBox.textContent = '';
    }

    if (alternativeTypesBox) {
      alternativeTypesBox.textContent = '';
    }

    if (recommendationNoteBox) {
      recommendationNoteBox.textContent = '';
    }

    showStep(1);

    finder.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  function goToNextStep() {
    const currentStepNode =
      steps.find(
        (step) =>
          Number(
            step.dataset.step
          ) === currentStep
      );

    if (!currentStepNode) {
      return;
    }

    const selectedInput =
      currentStepNode.querySelector(
        'input[type="radio"]:checked'
      );

    if (!selectedInput) {
      showError(
        'Veuillez sélectionner une réponse.'
      );

      return;
    }

    hideError();

    if (
      currentStep < 5
    ) {
      showStep(
        currentStep + 1
      );
    }
  }

  finder.addEventListener(
    'change',
    (event) => {
      const target =
        event.target;

      if (
        !(
          target instanceof
          HTMLInputElement
        ) ||
        target.type !==
          'radio'
      ) {
        return;
      }

      hideError();

      const stepNode =
        target.closest(
          '[data-step]'
        );

      if (!stepNode) {
        return;
      }

      const selectedStep =
        Number(
          stepNode.dataset.step
        );

      if (
        selectedStep !==
        currentStep
      ) {
        return;
      }

      if (
        currentStep < 5
      ) {
        window.setTimeout(
          goToNextStep,
          180
        );
      }
    }
  );

  finder.addEventListener(
    'click',
    (event) => {
      const nextButton =
        event.target.closest(
          '[data-next-step]'
        );

      if (nextButton) {
        event.preventDefault();
        goToNextStep();
        return;
      }

      const previousStepButton =
        event.target.closest(
          '[data-previous-step]'
        );

      if (
        previousStepButton
      ) {
        event.preventDefault();

        hideError();

        if (
          currentStep > 1
        ) {
          showStep(
            currentStep - 1
          );
        }

        return;
      }

      const findButton =
        event.target.closest(
          '[data-find-board]'
        );

      if (findButton) {
        event.preventDefault();
        runSearch();
        return;
      }

      const resetButton =
        event.target.closest(
          '[data-restart-finder]'
        );

      if (resetButton) {
        event.preventDefault();
        resetFinder();
      }
    }
  );

  finder.addEventListener(
    'keydown',
    (event) => {
      if (
        event.key !==
        'Enter'
      ) {
        return;
      }

      const target =
        event.target;

      if (
        target instanceof
          HTMLInputElement &&
        target.type ===
          'radio'
      ) {
        event.preventDefault();

        if (
          currentStep === 5
        ) {
          runSearch();
        } else {
          goToNextStep();
        }
      }
    }
  );

  showStep(1);
})();